export default {
    baseApiUrl: 'https://sv1.chimovo.com/v1/',
};


